module.exports = __webpack_public_path__ + "media/images/hortense-for-wedding/Groupe 30-f21e4d059f6b548b760ee4ec321f8bcb.png";